import axios from 'axios';
import { getGlobalConfig } from "./config";
const getDataOrThrow = resp => {
  if (!resp) throw new Error('无响应');
  if (resp.code !== 200) throw new Error(resp.error || resp.message || '响应内容有误');
  return resp.data;
};
export const getPrefixPath = () => {
  const {
    pathPrefix
  } = getGlobalConfig();
  // 给url添加host
  let fixPrefix = pathPrefix;
  if (!/^(http:|https:|\/\/)/.test(fixPrefix)) {
    // 适配 micro-app 微前端
    // @ts-ignore
    const MICRO_APP_ORIGIN = window.__MICRO_APP_PUBLIC_PATH__ ? new URL(window.__MICRO_APP_PUBLIC_PATH__).origin || '' : '';
    if (MICRO_APP_ORIGIN) {
      fixPrefix = `${MICRO_APP_ORIGIN}${fixPrefix}`;
    } else {
      fixPrefix = `//${location.host}${fixPrefix}`;
    }
  }
  return fixPrefix;
};
export const wujiRequest = async params => {
  const fixPrefix = getPrefixPath();
  // 有prefix一定不是带host的url
  const resp = await axios({
    baseURL: fixPrefix,
    ...params,
    withCredentials: true
  }).then(res => {
    if (res.status === 200) return res.data;
    throw new Error(`${res.status}: ${res.statusText}`);
  });
  return getDataOrThrow(resp);
};
//# sourceMappingURL=wujiRequest.js.map
